import { Select } from 'antd';

import './styles.scss';
import { BaseOptionType, DefaultOptionType, SelectProps } from 'antd/es/select';
import { ChevronDownIcon } from 'assets/icons/chevronDownIcon';
import {
  InputComponentWrapper,
  InputComponentWrapperProps,
} from 'baseComponents/InputComponentWrapper';

type SelectComponentProps<
  V,
  O extends BaseOptionType | DefaultOptionType,
> = SelectProps<V, O> &
  Pick<
    InputComponentWrapperProps,
    'error' | 'description' | 'fullWidth' | 'label'
  >;

export const SelectComponent = <
  ValueType = any,
  OptionType extends BaseOptionType | DefaultOptionType = DefaultOptionType,
>({
  error,
  description,
  label,
  fullWidth,
  ...rest
}: SelectComponentProps<ValueType, OptionType>) => (
  <InputComponentWrapper {...{ error, description, label, fullWidth }}>
    <Select<ValueType, OptionType>
      className='pj-select'
      popupClassName='pj-select-popup'
      suffixIcon={<ChevronDownIcon />}
      status={error ? 'error' : ''}
      {...rest}
    />
  </InputComponentWrapper>
);
